/* eslint-disable no-magic-numbers */
import { ColorTilePicker } from '@/shared/ColorPicker/ColorTilePicker.component';
import hexToRgbIntAlpha from '@/utils/convert/hexToRgbIntAlpha';
import { Color } from '@/types/models';
import { LayerRectFactoryForm } from '@/components/FunctionalArea/Modal/LayerRectFactoryModal/LayerRectFactory.types';
import { Input } from '@/shared/Input';
import {
  MAX_LINE_WIDTH,
  MIN_LINE_WIDTH,
} from '@/components/FunctionalArea/Modal/LayerLineFactoryModal/LayerLineFactory.constants';
import React from 'react';

type LayerRectFormProps = {
  data: LayerRectFactoryForm;
  onChange: (value: number | string | Color, key: string) => void;
};

export const LayerRectForm = ({ data, onChange }: LayerRectFormProps): React.JSX.Element => {
  const onBorderThicknessChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = Number(event.target.value);
    let resultValue = value;
    if (value < MIN_LINE_WIDTH) {
      resultValue = MIN_LINE_WIDTH;
    }
    if (value > MAX_LINE_WIDTH) {
      resultValue = MAX_LINE_WIDTH;
    }
    onChange(resultValue, 'borderThickness');
  };
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <span>Fill color:</span>
        <ColorTilePicker
          initialColor={data.fillColor}
          colorChange={color => onChange(hexToRgbIntAlpha(color), 'fillColor')}
        />
      </div>
      <div>
        <span>Border color:</span>
        <ColorTilePicker
          initialColor={data.borderColor}
          colorChange={color => onChange(hexToRgbIntAlpha(color), 'borderColor')}
        />
      </div>
      <div>
        <span>Border thickness:</span>
        <Input
          type="number"
          name="line-width"
          min={MIN_LINE_WIDTH}
          max={MAX_LINE_WIDTH}
          id="line-width"
          value={data.borderThickness}
          onChange={onBorderThicknessChange}
          className="text-sm font-medium text-font-400"
        />
      </div>
    </div>
  );
};
